// Carrusel del hero y formulario de presupuesto. Los datos salen de las secciones (editables en Shopify).
(function () {
  var dots = document.querySelectorAll("[data-dot]");
  if (dots.length) {
    var frame = document.querySelectorAll(".a3-hero-frame [data-slide]");
    var slide = 0, timer;
    var show = function (i) {
      slide = i;
      document.querySelectorAll("[data-a3-hero] [data-slide]").forEach(function (img) {
        img.style.opacity = +img.dataset.slide === i ? 1 : 0;
      });
      dots.forEach(function (b) {
        var on = +b.dataset.dot === i;
        b.style.width = on ? "34px" : "12px";
        b.style.background = on ? "#f3f2f2" : "rgba(243,242,242,0.42)";
      });
      var f = frame[i];
      if (f) {
        document.getElementById("a3-kicker").textContent = f.dataset.kicker || "";
        document.getElementById("a3-title").textContent = f.dataset.titulo || "";
      }
    };
    var start = function () { clearInterval(timer); timer = setInterval(function () { show((slide + 1) % dots.length); }, 5200); };
    dots.forEach(function (b) { b.addEventListener("click", function () { show(+b.dataset.dot); start(); }); });
    if (dots.length > 1) { start(); }
  }

  var form = document.getElementById("a3-presupuesto");
  if (form) {
    var texto = function () {
      var nombre = document.getElementById("a3-nombre").value.trim();
      var tipo = document.getElementById("a3-tipo").value;
      var mensaje = document.getElementById("a3-mensaje").value.trim();
      var t = "Hola Argent 3D, quiero pedir un presupuesto.\n\nQué necesito: " + tipo;
      if (nombre) { t += "\nNombre / negocio: " + nombre; }
      if (mensaje) { t += "\nDetalles: " + mensaje; }
      return t;
    };
    document.getElementById("a3-wa").addEventListener("click", function () {
      this.href = "https://wa.me/" + form.dataset.wa + "?text=" + encodeURIComponent(texto());
    });
    document.getElementById("a3-mail").addEventListener("click", function () {
      this.href = "mailto:" + form.dataset.mail + "?subject=" +
        encodeURIComponent("Presupuesto — " + document.getElementById("a3-tipo").value) + "&body=" + encodeURIComponent(texto());
    });
  }
})();
